import { useContext } from "react";
import { AnalyticsContext } from "../../../store/analyticsS";
import { HotelContext } from "../../../store/hotel";
import CustomDateRangePicker from "../../analytics/components/DateRangePicker";
import LoadingBookings from "../../common/LoadingBookings";
import Constant from "../../../constant/Constant";
import SalesGraph from "../../graph/booking/SalesGraph";
import SingleHotelUserAnalyticsViewer from "../component/SingleHotelUserAnalyticsViewer";

const UserAnalyticsBookingScreen = () => {
  const analyticsContext = useContext(AnalyticsContext);
  const hotelContext = useContext(HotelContext);
  let bookingAnalytics = analyticsContext.userAnalytics;
  let allHotels = Object.keys(bookingAnalytics);

  const dateContent = (
    <div style={{ position: "absolute", top: "15px", left: "30px", zIndex: 4 }}>
      <CustomDateRangePicker
        startDay={hotelContext.startDay}
        days={hotelContext.days}
        onDateChange={(date, days) => {
          hotelContext.onUpdateDate(date, days);
        }}
      />
    </div>
  );

  if (
    analyticsContext.isUserAnalyticsLoading ||
    !analyticsContext.isUserAnalyticsLoaded
  ) {
    return (
      <>
        {dateContent}
        <LoadingBookings />
      </>
    );
  }

  return (
    <>
      {dateContent}
      {allHotels.length > 0 && (
        <SalesGraph
          bookingAnalytics={bookingAnalytics}
          title="User Analytics"
          allOptions={Constant.UserBookingsSourcesShort}
          isTablularData={analyticsContext.isTabularData}
          onToggleTabularData={() => {
            analyticsContext.onToggleTabularData();
          }}
          isBar={analyticsContext.isBar}
          isHotel={analyticsContext.isHotel}
          isDate={analyticsContext.isDate}
          isPercentage={analyticsContext.isPercentage}
          onTogglePercentage={() => {
            analyticsContext.onTogglePercentage();
          }}
          onToggleBar={() => {
            analyticsContext.onToggleBar();
          }}
          onToggleHotel={() => {
            analyticsContext.onToggleHotel();
          }}
          onToggleDate={() => {
            analyticsContext.onToggleDate();
          }}
        />
      )}
       {!analyticsContext.isTabularData &&
        allHotels.map((hotel) => {
          return (
            <SingleHotelUserAnalyticsViewer
              key={hotel}
              hotelName={hotel}
              allDateData={bookingAnalytics[hotel]}
            />
          );
        })}
    </>
  );
};

export default UserAnalyticsBookingScreen;
